<div [ngClass]="classNames" class="_pill-thin-inverted _text-sm _py-1 _inline-block _border-0 _text-black _shadow-sm">
    <ng-content></ng-content>
</div>
